import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'
import { isArray, isEmpty } from 'lodash-es'

import { ModalComponent } from '..'

import './ErrorModalComponent.scss'

const renderMessage = (message, errorType, liveId) => {
  if (errorType === 'ice_connection_error') {
    const testLink = `/webinar/producer/${liveId}/test`

    return (
      <div>
        <p>
          <FormattedMessage defaultMessage="Darn! We could not establish a connection to the live server. A common reason for this are corporate networks restricting or blocking the connection." />
        </p>
        <p>
          <FormattedMessage
            defaultMessage="Please take a look at our <link>Help Center</link> for instructions on setting up your firewall and forward it to your IT department, if necessary."
            values={{
              link: (...chunks) => (
                <a
                  href="https://www.twentythree.net/help/network-setup-for-running-webinars"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
        <p>
          <FormattedMessage
            defaultMessage="You can then use the <link>Connection Test</link> to test your connectivity."
            values={{
              link: (...chunks) => (
                <a href={testLink} target="_blank" rel="noopener noreferrer">
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
        <p>
          <FormattedMessage
            defaultMessage="If you are still experiencing issues after that, do not hesitate to <link>contact support</link>."
            values={{
              link: (...chunks) => (
                <a href="mailto:support@twentythree.net">{chunks}</a>
              ),
            }}
          />
        </p>
      </div>
    )
  }

  if (isArray(message)) {
    // eslint-disable-next-line react/no-array-index-key
    return message.map((msg, idx) => <p key={idx}>{msg}</p>)
  }

  return <p>{message}</p>
}

const ErrorModalComponent = ({ message, errorType, liveId, title }) => (
  <ModalComponent
    wrapClassName="error-modal-component"
    visible
    closable={false}
    width={339}
  >
    {!isEmpty(title) && <h1>{title}</h1>}
    <img
      src="/resources/um/graphics/critical_error.png"
      alt={intl.formatMessage({ defaultMessage: 'Critical error icon' })}
    />
    {renderMessage(message, errorType, liveId)}
  </ModalComponent>
)

ErrorModalComponent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  errorType: PropTypes.string,
  liveId: PropTypes.string,
}

ErrorModalComponent.defaultProps = {
  title: 'Critical error',
  message: 'A critical error occurred',
}

export default ErrorModalComponent
